<template>
  <b-container>
    <b-card border-variant="danger" :header="$t('Login.header')" header-bg-variant="danger" header-text-variant="white" align="left">
      <b-form @submit="onSubmit">
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('Login.emailPlaceholder')" v-model="email" type="email"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('Login.passwordPlaceholder')" type="password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1 text-right">
          <b-col>
           <router-link :to="{name: 'ForgotPassword'}">{{$t('Login.forgotPassword')}}</router-link>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-button variant="danger" type="submit">{{ $t('Login.loginButton') }}</b-button>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-alert :show="error.received" variant="danger" class="text-center">{{error.msg}}</b-alert>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
/* CONTROLLER */
import AuthenticationService from '@/services/AuthenticationService'
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      error: {
        received: false,
        msg: ''
      }
    }
  },
  mounted () {
    // if already logged in, redirect to home page
    this.redirect()
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.login()
    },
    async login () {
      try {
        const response = await AuthenticationService.login({
          email: this.email,
          password: document.querySelector('input[type="password"]').value
        })
        // set store state for token and user
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        // redirect to home page
        this.$router.push({ name: 'Home' })
      } catch (error) {
        this.error.received = true
        if (error.response.data.error === 'userNotFound') {
          this.error.msg = this.$i18n.t('Login.serverMessages.userNotFound')
        } else if (error.response.data.error === 'incorrectPassword') {
          this.error.msg = this.$i18n.t('Login.serverMessages.incorrectPassword')
        } else if (error.response.data.error === 'Invalid password') {
          this.error.msg = this.$i18n.t('Login.serverMessages.invalidPassword')
        } else {
          this.error.msg = this.$i18n.t('Login.serverMessages.generic')
        }
      }
    },
    redirect () {
      let smartdineLocalStorage = JSON.parse(window.localStorage.getItem('smartdine'))

      if (this.isUserLoggedIn || smartdineLocalStorage.token) this.$router.push({ name: 'Home' })
    }
  },
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'isUserLoggedIn'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue